import { render, staticRenderFns } from "./choseService.vue?vue&type=template&id=6dd294ae&"
import script from "./choseService.vue?vue&type=script&lang=js&"
export * from "./choseService.vue?vue&type=script&lang=js&"
import style0 from "./choseService.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports